// extracted by mini-css-extract-plugin
export var sbShowMain = "tip-module--sb-show-main--TsRlb";
export var wrapper = "tip-module--wrapper--NG2vp";
export var note = "tip-module--note--2Lw0j";